// Configuration des URLs de l'application
export const BASE_PATH = ''; // Peut être modifié pour un préfixe spécifique si nécessaire

export const getUrl = (path: string = '', token?: string): string => {
  // Supprime les slashs en double
  const cleanPath = path.replace(/^\/+|\/+$/g, '');
  const cleanToken = token ? token.replace(/^\/+|\/+$/g, '') : '';
  
  if (cleanToken) {
    return `/${cleanPath}/${cleanToken}`.replace(/\/+/g, '/');
  }
  
  return `/${cleanPath}`.replace(/\/+/g, '/');
};

export const ROUTES = {
  HOME: getUrl(''),
  HOMEPAGE: '/accueil',
  QUIZ: (token?: string) => getUrl('quiz', token),
  SCORE: (token?: string) => getUrl('score', token),
  PLAN: (token?: string) => getUrl('plan', token),
  THANKS: (token?: string) => getUrl('merci', token),
  LOGIN: '/login',
  ADMIN: '/mon-espace',
  ADMIN_PROSPECTS: '/mon-espace/prospects',
  ADMIN_PROSPECT_DETAIL: (id: string) => `/mon-espace/prospect/${id}`,
  ADMIN_QUIZ: '/mon-espace/quiz',
  ADMIN_ANALYTICS: '/mon-espace/analytics',
  ADMIN_SITE_ANALYSIS: '/mon-espace/site-analysis',
  ADMIN_CAMPAIGNS: '/mon-espace/campaigns',
  ADMIN_MESSAGES: '/mon-espace/messages',
  // Route de test pour la page refactorisée TestPage_copy (accepte un token optionnel)
  TEST_COPY: (token?: string) => getUrl('test-copy', token),
  // Nouvelle route pour l'analyse de performance de page
  PAGE_PERFORMANCE: (prospectId: string, url: string) => `/prospects/${prospectId}/page-performance/${url}`,
};
